module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Klingnau-291a1d090fa057c2d075258f7f9bd7ec.svg";